'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtView', [
	'$timeout',
	'$window',
	'auth',
	'$rootScope',
	'$templateCache',
	'pmtEnvService',
	'$stateParams',
	function ($timeout, $window, auth, $rootScope, $templateCache, pmtEnvService, $stateParams) {
		return {
			restrict: 'A',
			replace: true,
			transclude: true,
			scope: {
				pageTitle: '@',
				loading: '@',
				unsavedChanges: '@',
				showGlobalBanners: '=?',
				savedChanges: '=savedChanges'
			},
			link: function (scope, element, attrs) {
				scope.showGlobalBanners = angular.isUndefined(scope.showGlobalBanners)
					? true
					: scope.showGlobalBanners;

				function setArgs(user) {
					const site = $stateParams.site;
					const access = user.accountAccess[site] || {};
					scope.args = {
						sitesCount: user.sites ? user.sites.length : 0,
						accountAccess: {
							hasListenRespond: access.hasListenRespond || false,
							hasPlaces: access.hasPlaces || false,
							hasSocialMedia: access.hasSocialMedia || false,
							hasAccountAccess: user.localAccess.roles.has('owner'),
							hasLocator: access.hasLocator || false,
							hasLocalCampaigns: access.hasLocalCampaigns || false,
							hasAiVisibility: access.hasAiVisibility || false
						},
						accountSettings: pmtEnvService.accountSettingsUrl + site,
						listen: pmtEnvService.listenRespondUrl + site,
						social: pmtEnvService.locationPostsUrl + site,
						switchAccounts: pmtEnvService.listingsManagerUrl + 'switch-accounts',
						logout: pmtEnvService.loginUrl + 'logout'
					};
				}

				if ($stateParams.site) {
					auth
						.getUser($stateParams.site)
						.then(function (user) {
							scope.user = user;
							setArgs(user);
						})
						.catch(() => setArgs({}));
				}

				$timeout(function () {
					let contentElement = element[0];
					contentElement.focus();
				}, 300);

				scope.showSavedChanges = false;
				scope.$watch(
					'savedChanges',
					function (val) {
						if (val === true || val === 'true') {
							scope.showSavedChanges = true;
							scope.savedChanges = false; // do a reset so it can be runned again
							$timeout(function () {
								scope.showSavedChanges = false;
							}, 2200);
						}
					},
					true
				);

				scope.historyBack = function () {
					$window.history.back();
				};

				scope.keyUp = function (e) {
					$rootScope.$broadcast('pmtViewKeyUp', e.keyCode);
				};

				scope.$on('pmtNetworkDown', function () {
					scope.networkError = true;
				});
				scope.$on('pmtServerError', function (_ns, { message }) {
					scope.serverError = message;
				});

				scope.$on('pmtInsufficientPermissionsError', function () {
					auth.reloadUser($stateParams.site).then(function () {
						let roles = auth.getUserRoles();
						if (roles.indexOf('owner') === -1 && roles.indexOf('customersuccess') === -1) {
							scope.noPlacesAccess = true;
							scope.socialAppUrl = pmtEnvService.locationPostsUrl;
						} else {
							scope.insufficientPermissionsError = true;
						}
					});
				});
				scope.userIsOwner = auth.user.localAccess.roles.has('owner');

				scope.closeNetworkError = function () {
					scope.networkError = false;
				};
				scope.closeServerError = function () {
					scope.serverError = '';
				};
				scope.closeInsufficientPermissionsError = function () {
					scope.insufficientPermissionsError = false;
				};
				scope.$watch('pageTitle', function (newVal /*, oldVal*/) {
					if (scope.user) {
						$window.document.title = scope.user.selectedSite.displayName + ': ' + (newVal || '');
					}
				});

				//This observes needs to cast the new value from string type to "real" boolean type for angular expressions like ng-if to work after version1.3*
				attrs.$observe('loading', function () {
					scope.loading = scope.$eval(attrs.loading);
				});
				attrs.$observe('unsavedChanges', function () {
					scope.unsavedChanges = scope.$eval(attrs.unsavedChanges);
				});
			},
			template: $templateCache.get('directive-templates/pmtView.html')
		};
	}
]);
